import css from "styled-jsx/css";
import Colors from "/styles/colors";
import { BRAND_PRIMARY_YELLOW } from "styles/color-consts";

const BUTTON_HEIGHT = 90;

export const componentStyles = css.global`
  .live-board-open-button {
    pointer-events: auto;
    display: flex;
    flex-direction: row;
    background-color: ${Colors[BRAND_PRIMARY_YELLOW]};
    border-top-left-radius: 96px;
    border-bottom-left-radius: 96px;
    cursor: pointer;
    height: 90px;
    margin-top: calc(10vh + ${BUTTON_HEIGHT / 2}px);
    .button-text {
      text-align: left;
      padding-left: 28px;
      width: 130px;
      align-self: center;
      .paragraph-body {
        font-size: 14px;
        line-height: 16px;
      }
    }

    .button-right-section {
      display: flex;
      align-items: end;
      .board-image-wrapper {
        width: 100%;
        position: relative;
        .picture-component {
          display: flex;
          img {
            max-height: 76px;
          }
        }
        .pulse-circle {
          position: absolute;
          top: 45%;
          left: 35%;
          background: #f17c57fa;
          align-self: center;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          box-shadow: 0px 0px 1px 1px;
          animation: pulse-animation 2s infinite;
        }
        .pointer-wrapper {
          position: absolute;
          top: 6px;
          left: 8px;
          .picture-component {
            img {
              max-height: 16px;
            }
          }
        }
      }
    }
  }

  @keyframes pulse-animation {
    0% {
      box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
    }
    100% {
      box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
    }
  }
`;
